// @flow
import React, { Fragment } from "react";
import { Box, Button, Control, Input } from "biologiatotal-ui";
import { withRouter } from "react-router-dom";
import Form from "../../../components/form";
import { Link } from "react-router-dom";
import "./recoverPassword.scss";

import formSchema from "./schema";
import { bindActionCreators } from "redux";
import { doRecoverRequest } from "../../../account";
import connect from "react-redux/es/connect/connect";

const title = "ESQUECI A SENHA";
const description =
  "Insira o seu e-mail cadastrado no Aprova Total para receber as instruções de redefinição da sua senha:";

class RecoverPassword extends Form {
  constructor(props) {
    super(props, formSchema);
  }

  doRecover = e => {
    e.preventDefault();
    this.validate().then(() => this.onRecover());
  };

  onRecover = () => {
    const { doRecoverRequest, history } = this.props;
    doRecoverRequest(this.state.values.email).then(() => history.replace("/recupera-sucesso"));
  };

  render() {
    const { values, errors } = this.state;
    const { isRecovery, match } = this.props;

    return (
      <Fragment>
        <div className="columns recover-panel">
          <div className="column centered is-4 is-offset-4">
            <Box className="recover-panel-content">
              <div className="recover-panel-header">
                <span>{title}</span>
              </div>
              <div>
                <span className="recover-panel-header-texttwo">{description}</span>
              </div>
              <form>
                <div className="recover-panel-form">
                  <Control className="logininput recover-panel-form-control">
                    <span className="recover-panel-form-label">Seu e-mail:</span>
                    <Input
                      type="email"
                      className="recover-panel-form-input"
                      placeholder="Login"
                      danger={!!errors.email}
                      value={values.email}
                      onChange={e => this.update("email", e.target.value.toLowerCase())}
                    />
                    <p className="help is-danger recover-panel-form-info">{errors.email}</p>
                  </Control>
                </div>
                <Button
                  gradientLink
                  large
                  loading={isRecovery}
                  className="btn recover-panel-form-button"
                  onClick={this.doRecover}>
                  <span className="recover-panel-form-button-span">ENVIAR</span>
                </Button>
              </form>
            </Box>
            {match.params.content === "nova-plataforma" ? (
              <div className="recover-panel-back-login">
                <span className="recover-panel-back-login-label"> Já passou por essa etapa? </span>
                <Link to="/management/login">Faça seu login</Link>
              </div>
            ) : (
              <div className="recover-panel-back-login">
                <Link to="/management/login">Voltar para o login</Link>
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    recovery: state.account.data.recovery,
    isRecovery: state.account.ui.isRecovery
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      doRecoverRequest
    },
    dispatch
  );
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(RecoverPassword);

Connected.displayName = "RecoverPassword";

export default withRouter(Connected);
